function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}
parcelRequire.register("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = {};
function $ef7689007096c8a0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ef7689007096c8a0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $6e1b225390d4db5f$exports = {};

(parcelRequire("kyEFX")).register(JSON.parse('{"bK9uH":"shopping-list.c328412f.js","kONVj":"Yaroslav_Matvieiev.5d8f5fe2.jpg","1IF0Z":"Denys_Lavryk.af261305.jpg","jYlnj":"Anastasiia_Vedmid.6ca2fc2e.jpg","j3ikF":"Marina_Sihida.33350952.jpg","1kuoP":"Vitalii_Duduka.62284618.jpg","loLvE":"Mary_Kuzo.54a21753.jpg","ap6uD":"Oleksii_Burlaka.0c514305.jpg","bHhaY":"Victory_Krasova.9923d6fc.jpg","k6Zqt":"Artem_Zaicew.b1be3a25.jpg","lYbab":"Oleksii_Khodarchenko.d12245be.jpg","hkegz":"oleg_kryuchkov.4f6bf2d5.jpg","5uhR4":"save-children.4bc49885.png","8TtpK":"save-children-2x.344c3429.png","fi7NC":"project-hope.ee1dff41.png","5Bn4V":"project-hope-2x.68dcba1c.png","2UzZv":"united24.09710d57.png","aE4lN":"united24-2x.49f947bd.png","2tHZe":"international-medical-corps.6d8da1c0.png","5acO9":"international-medical-corps-2x.78bf59d8.png","904s3":"medicins-sans-frontiers.69d60c87.png","3XGhi":"medicins-sans-frontiers-2x.d7188d89.png","3x5pU":"razom.937888e8.png","gjTTp":"razom-2x.13d5fee6.png","apIhs":"action-against-hunger.5d4e3dc5.png","6QJ0Q":"action-against-hunger-2x.ee0d520d.png","dEjmM":"world-vision.c3b99688.png","fjGd2":"world-vision-2x.8fa48756.png","aSK1Y":"sergiy-prytula.bfca1697.png","iE5bT":"sergiy-prytula-2x.84af21b4.png"}'));


//# sourceMappingURL=shopping-list.f8af9a2e.js.map
